module.exports = __webpack_public_path__ + "img/opes-logo.c732d957.jpg";